module.exports = __webpack_public_path__ + "img/guanli.df0e703f.png";